export const firebaseConfig = {
	apiKey: "AIzaSyBqcDxcee6h_KwvomVsWgWaBzm-u69eDyQ",
	authDomain: "vortex.tarydium.com",
	databaseURL: "https://vortex-cd5ea.firebaseio.com",
	storageBucket: "vortex-cd5ea.appspot.com",
	messagingSenderId: "256016693987"
}
